/*
 * File: /src/router/routes/tasks.js
 * Created Date: Monday August 16th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 16th August 2021 11:46:48 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
const TasksList = () =>
  import(
    /* webpackChunkName: "Tasks" */ 'src/components/Dashboard/Views/Tasks/TasksList.vue'
  );

const TasksDetail = () =>
  import(
    /* webpackChunkName: "Tasks" */ 'src/components/Dashboard/Views/Tasks/TasksDetail.vue'
  );

export const taskRoutes = [
  {
    path: 'tasks/view',
    name: 'Tasks',
    component: TasksList,
    props: route => ({ userId: parseInt(route.query.user_id) })
  },
  {
    path: 'tasks/view/:taskId',
    name: 'Tasks Detail',
    component: TasksDetail
  }
];
